import { Component, inject, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucideEye } from '@ng-icons/lucide';
import { CheckboxSubmenuItemComponent } from '@shared/components/checkbox-submenu-item/checkbox-submenu-item.component';
import { ExpansionPanel, ExpansionPanelMenuAction } from '@shared/components/expansion-panel/expansion-panel.component';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmItemSeparator } from '@spartan-ng/helm/item';
import { InterrelationStore } from '../../../../../référentiel-métier/référentiel-metier-interrelations/store/interrelation.store';
import { Aptitude } from '../../../../../référentiel-métier/référentiel-métier-processus/processus-aptitude/models/aptitude.model';
import { Production } from '../../../../../référentiel-métier/référentiel-métier-processus/processus-aptitude/models/production.model';
import { FormControlNames } from '../../../../models/form-control-names.model';
import { DetailObjectifsFormGroup } from '../../detail-form-groups.types';
import { EtapeDetailFormService } from '../../étape-detail-form.service';

@Component({
  selector: 'app-detail-aptitude-item',
  imports: [ExpansionPanel, CheckboxSubmenuItemComponent, HlmItemSeparator, TrierParPipe, HlmIconImports],
  templateUrl: './detail-aptitude-item.component.html',
  providers: [provideIcons({ lucideEye })],
})
export class DetailAptitudeItemComponent {
  readonly #etapeFormService = inject(EtapeDetailFormService);
  readonly interrelationStore = inject(InterrelationStore);

  readonly aptitude = input.required<Aptitude>();
  readonly form = input.required<DetailObjectifsFormGroup>();
  readonly canCheck = input.required<boolean>();

  readonly aptitudeManuelleActions: ExpansionPanelMenuAction<Aptitude>[] = [
    {
      icon: 'lucideTrash',
      label: "Supprimer l'aptitude de l'étape",
      action: (aptitude) => this.#supprimerAptitude(aptitude),
    },
  ];

  redirectToRessourcesPro(idProduction: string) {
    const url = location.href;
    const fragments = url.split('/').slice(0, 7);
    fragments.push(`ressources-professionnelles?idProduction=${idProduction}`);
    window.open(fragments.join('/'), '_blank');
  }

  getInterrelationsParPhase() {
    const aptitude = this.aptitude();
    return this.interrelationStore.parPhase(aptitude.idPhase).map((x) => ({
      ...x,
      value: { id: `${aptitude.id}-${x.id}`, nom: x.nom, idInterrelation: x.id, idAptitude: aptitude.id },
    }));
  }

  #supprimerAptitude(aptitude?: Aptitude) {
    if (!aptitude) return;

    const aptitudes = (this.#etapeFormService.aptitudes.value as Aptitude[]).filter((x) => x.id !== aptitude.id);
    this.#etapeFormService.aptitudes.clear();
    aptitudes.forEach((a) => this.#etapeFormService.ajouterAptitude(a));
  }

  get aptitudes() {
    return this.form().get(FormControlNames.APTITUDES) as AbstractControl<Aptitude[]>;
  }

  get interrelations() {
    return this.form().get(FormControlNames.INTERRELATIONS) as AbstractControl<{ id: string }[]>;
  }

  get productions() {
    return this.form().get(FormControlNames.PRODUCTIONS) as AbstractControl<Production[]>;
  }
}
